import { Component } from "preact";
// eslint-disable-next-line no-unused-vars
import PropTypes from "prop-types";
import { combineClasses, E_Modification } from "@green24/npm-javascript-utils";
import Interpret from "../Localization/Interpret";
import ButtonsConstructor from "./Button/ButtonsConstructor";

class OptionsInput extends Component {
	render({className, style, value, path, onModify, label, options, isActive, onValue, labelTranslated, disabled}) {
		return (
			<section className={combineClasses("options", className)} style={style}>
				<label>
					{
						label &&
						<h2>
							{
								labelTranslated &&
								label
								||
								<Interpret id={label}/>
							}
						</h2>
					}
				</label>

				<nav>
					<ButtonsConstructor buttons={options.map((option) => {
						const active = isActive(value, option);
						return {
							...option,
							action: () => onModify(onValue(option), path, E_Modification.ITEM_SET),
							active,
							accent: active ? option.accentOnActive : option.accent,
							elevation: active,
							outline: !active,
							disabled,
						}
					})}/>
				</nav>
			</section>
		);
	}

	static get propTypes() {
		return {
			options: PropTypes.array.isRequired,
			value: PropTypes.any,
			path: PropTypes.string,
			onModify: PropTypes.func,
			label: PropTypes.any,
			labelTranslated: PropTypes.bool,
			disabled: PropTypes.bool,

			isActive: PropTypes.func,
			onValue: PropTypes.func,
		}
	}

	static get defaultProps() {
		return {
			onModify: (value, path, type = E_Modification.ITEM_SET) => null,
			value: false,
			isActive: (value, option) => option.value == value,
			onValue: (data) => data.value,
		}
	}
}

export default OptionsInput;
